import React, { useEffect, useState } from 'react';
import './App.css';

const App: React.FC = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className="relative min-h-screen w-full overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0 w-full h-full z-0">
        {isLoaded && (
          <video
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
            className="absolute inset-0 w-full h-full object-cover z-10"
            poster=""
          >
            <source src="/videos/back_video.webm" type="video/webm" />
            Your browser does not support the video tag.
          </video>
        )}

        {/* Video overlay for better text readability */}
        <div className="absolute inset-0 bg-black/20" />

        {/* Fallback animated background (shows if video fails to load) */}
        <div className="absolute inset-0 bg-black">
          {/* Animated starfield fallback */}
          <div className="absolute inset-0">
            {[...Array(100)].map((_, i) => (
              <div
                key={i}
                className="absolute bg-white rounded-full opacity-60 animate-pulse"
                style={{
                  left: `${Math.random() * 100}%`,
                  top: `${Math.random() * 100}%`,
                  width: `${Math.random() * 2 + 1}px`,
                  height: `${Math.random() * 2 + 1}px`,
                  animationDelay: `${Math.random() * 3}s`,
                  animationDuration: `${Math.random() * 2 + 2}s`
                }}
              />
            ))}
          </div>

          {/* Fallback cosmic gradient */}
          <div className="absolute inset-0 bg-gradient-radial from-purple-900/40 via-blue-900/30 to-black" />

          {/* Fallback central glow */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 md:w-96 md:h-96 bg-gradient-radial from-orange-500/20 via-blue-500/10 to-transparent rounded-full animate-pulse" />
        </div>
      </div>

      {/* Content Overlay */}
      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-4 sm:px-6 lg:px-8 text-center">
        {/* Main Title */}
        <div className={`transition-all duration-2000 ease-out mt-20 md:mt-40 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h1 className="font-sweet-sans text-[30px] sm:text-[60px] md:text-[80px] lg:text-[100px] font-extralight text-[#E7E7E7] mb-4 tracking-[0.1em] md:tracking-[0.2em] leading-none">
            {['L', 'U', 'M', 'O', 'R', 'A', ' ', 'N', 'O', 'V', 'A'].map((letter, index) => (
              <span
                key={index}
                className={`inline-block animate-fadeInUp opacity-0 ${letter === ' ' ? 'mx-2 sm:mx-4 md:mx-6 lg:mx-8' : ''
                  }`}
                style={{
                  animationDelay: `${0.5 + index * 0.1}s`,
                  animationFillMode: 'forwards',
                  textShadow: '0 0 8px black, 0 0 12px black, 0 0 16px black'
                }}
              >
                {letter}
              </span>
            ))}
          </h1>
        </div>

        {/* Subtitle */}
        <div className={`transition-all duration-2000 delay-1000 ease-out ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="font-nunito text-[18px] sm:text-[24px] md:text-[28px] lg:text-[32px] font-light text-[#E7E7E7] mb-6 md:mb-8 tracking-[0.2em] sm:tracking-[0.3em] md:tracking-[0.4em] leading-none px-2">
            WE'RE COMING SOON
          </p>
        </div>

        {/* Floating Logo */}
        <div
          className={`mt-[-20px] md:mt-[-40px] transition-all duration-2000 delay-1500 ease-out ${isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
        >
          <div className="relative">
            {/* Logo Container with floating animation */}
            <div className="w-[100px] h-[67px] sm:w-[130px] sm:h-[87px] md:w-[168px] md:h-[112px] animate-float relative flex items-center justify-center">
              {/* Glow effects */}
              <div className="absolute inset-0 bg-gradient-radial from-orange-500/30 via-blue-500/20 to-transparent rounded-full animate-pulse blur-sm"></div>
              <div
                className="absolute inset-0 bg-gradient-radial from-transparent via-orange-400/10 to-transparent rounded-full animate-pulse"
                style={{ animationDelay: "1s" }}
              ></div>

              {/* Image overlay */}
              <img
                src="/images/logo.png"
                alt="Floating Logo"
                className="absolute w-full h-full object-contain z-10"
              />
            </div>
          </div>
        </div>

      </div>

      {/* Custom Styles */}
      <style>{`
        @media (max-width: 640px) {
          .animate-fadeInUp {
            animation: fadeInUp 1s ease-out forwards;
          }
        }
        
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default App;